module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAATNJREFUOE+tlD1Ow0AQhd+sLBFqX4AOukhwACQ6DmHvuoCgUOGDJFUIGFn+OwRdJC6AoIOOC9gtUHgHrSEoGGMH8Ja7M5/2zb63hB4W1RlhGA4tyzoGcABg6+P8CcBCCBE4jnNf7/mERFE0IKIpERmA+OGCmpmDoih83/eflzUVZDKZbNq2fQ1gf011N3meHy5BFSRN0zkzn9QBrutWW2maNrEvpZRVD2VZNtRa3zZJ6IBoIcSumRElSTIDMF5TRr3sXEp5aiAPALb/CHmUUu5QHMcvRLTRBOmQA2Z+VUoN+oG0yem6CYB3OW2D7YIw81wpNf7XE2ut9zzPu6vMliTJBYDRb8xm7K+Uqnr6s/1KfqYAjtoCCOAqz/OzbwFclWFiwMwjZv7yFRDRoizLwMygLvsNf2ekEnU4K7IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/info.png
// module id = jCfu
// module chunks = 2